/**
 * Label-over-big-value stat tile. Used in quiz question displays
 * (POT / VILLAIN BETS / OUTS / etc.) — five quiz routes had identical
 * copies of this widget; consolidated here.
 */

interface StatProps {
  label: string;
  value: string;
  /** Whether to tint the value with the accent color (used for the
   *  "primary" stat in each row, e.g. villain's bet, the out count). */
  accent?: boolean;
  /** Visual size of the value. Defaults to `md` (3xl). */
  size?: "md" | "sm";
}

export function Stat({ label, value, accent = false, size = "md" }: StatProps) {
  const valueClasses = `${size === "sm" ? "text-2xl" : "text-3xl"} font-bold tracking-tight ${accent ? "text-accent" : "text-text"}`;
  return (
    <div className="text-center">
      <div className="text-[10px] uppercase tracking-wider text-text-muted mb-1">{label}</div>
      <div className={valueClasses}>{value}</div>
    </div>
  );
}
